import {
  ApisauceInstance
} from 'apisauce';

// Url
import { url } from '../api.url';

const ChemicalProbes = (api: ApisauceInstance) => {

  const getChemicalProbesById = (id: string) => api.get(`${url.getChemicalProbesById}/${id}`);
  const getCompoundsInactiveControlById = (id: string) => api.get(`${url.getInactiveControlById}/${id}`);

  return {
    getChemicalProbesById,
    getCompoundsInactiveControlById,
  };
};

export default ChemicalProbes;
